import { type FC } from "react";

import { faRobot } from "@fortawesome/pro-duotone-svg-icons/faRobot";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { type Agent, type Conversation, type Project } from "@app_schema";

import { BasicLink } from "@styled/basic_link";

export const ConversationHeader: FC<{
  conversation: Pick<Conversation, "id"> & {
    agent: Pick<Agent, "id" | "name">;
    project?: Pick<Project, "id" | "name"> | null;
  };
}> = ({ conversation }) => (
  <div className="flex items-center gap-4 border-b border-slate-200 bg-white p-4">
    <div className="flex size-12 shrink-0 items-center justify-center rounded-md bg-linear-to-br from-violet-500 to-violet-600 text-white">
      <FontAwesomeIcon icon={faRobot} className="size-5" />
    </div>
    <div className="flex min-w-0 flex-col gap-0.5">
      <div className="truncate text-lg font-semibold text-slate-900">
        {conversation.agent.name}
      </div>
      <div className="flex items-center gap-2 text-sm text-slate-500">
        <span>Conversation #{conversation.id}</span>
        {conversation.project && (
          <>
            <span>&middot;</span>
            <BasicLink to={`/dashboard/projects/${conversation.project.id}`}>
              {conversation.project.name}
            </BasicLink>
          </>
        )}
      </div>
    </div>
  </div>
);
